/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySummaryResponse {
    getFixupPrototypeFunction() { return CostAnomalySummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySummaryResponse>): CostAnomalySummaryResponse {
        let obj = Object.assign(new CostAnomalySummaryResponse(), model);
        CostAnomalySummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySummaryResponse>): CostAnomalySummaryResponse {
        if (!model) return null;
        return CostAnomalySummaryResponse.newInstance(<CostAnomalySummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySummaryResponse) {
        if (!obj) return;

        models.CostAnomalySummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySummaryResponse): boolean {
        Object.setPrototypeOf(obj, CostAnomalySummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.details) {
            for (let val of this.details) {
                models.CostAnomalySummaryAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Cost Anomaly account  wise daily summary
     */
    details: Array<models.CostAnomalySummaryAccount>;

}
